import { useEffect } from "react";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

const ENGAGEMENT_METRIC_NAME = "React Component Engaged Time (seconds)";

function useAppInsightsTracking(componentName: string) {
    const appInsights = useAppInsightsContext();

    useEffect(() => {
        if (!appInsights) {
            return;
        }

        appInsights.trackPageView({
            name: componentName,
        });

        appInsights.trackMetric(
            {
                average: 5,
                name: ENGAGEMENT_METRIC_NAME,
                sampleCount: 1,
            },
            {
                "Component Name": componentName,
            },
        );
    }, [appInsights, componentName]);

    return appInsights;
}

export default useAppInsightsTracking;
